// Shopify Forms App Styling for Contact Form
// This script styles the Shopify Forms app that uses shadow DOM
// which cannot be styled with regular CSS
//
// Visual language matches the glassmorphism card in
// theme/sections/norcal-contact-page.liquid (the "Send Us a Message" hero
// directly above this form) so the two sections read as one continuous flow:
// --steel: #7d9bb2, --steel-deep: #506374, --card-head: #586a78 (input text),
// --card-ink: #3f4b55 (muted micro-labels). See input/Contact Us (standalone).html
// for the original reference design (Name/Phone/Email/Select/Message card).

;(() => {
  // Configuration - update these values to match your form styling preferences
  const FORM_STYLES = {
    container: {
      "border-radius": "14px",
      border: "none",
      "background-color": "#ffffff",
      "box-shadow": "none",
      padding: "40px 44px",
      "max-width": "720px",
      width: "100%",
      margin: "0 auto",
      "box-sizing": "border-box",
    },

    inputs: {
      "border-radius": "8px",
      border: "1px solid rgba(55,54,59,0.16)",
      padding: "13px 15px",
      "font-family": "Montserrat, sans-serif",
      "font-size": "15px",
      color: "#586a78",
      "background-color": "#fff",
      width: "100%",
      "box-sizing": "border-box",
      transition: "border-color 0.2s ease",
    },

    // Static uppercase micro-label sitting above each field (not a floating
    // placeholder). The app's own bundled stylesheet defaults this label to
    // position:absolute (it's normally an overlay placeholder inside the
    // input), so position/pointer-events/background/inset MUST be reset
    // here or it keeps floating on top of the input and blocks clicks/typing.
    // `order` (on a column-flex field container) moves it above the input
    // visually without touching DOM order, since the label is the input's
    // next sibling in the markup.
    labels: {
      "font-size": "10px",
      "font-weight": "700",
      "letter-spacing": "0.18em",
      "text-transform": "uppercase",
      color: "#3f4b55",
      "margin-bottom": "8px",
      order: "-1",
      display: "block",
      position: "static",
      top: "auto",
      left: "auto",
      inset: "auto",
      transform: "none",
      "pointer-events": "none",
      "background-color": "transparent",
      padding: "0",
      border: "none",
      "border-bottom": "none",
      "box-shadow": "none",
      "font-family": "Montserrat, sans-serif",
      opacity: "1",
      visibility: "visible",
      "line-height": "1.4",
      "white-space": "normal",
      overflow: "visible",
      height: "auto",
      "min-height": "0",
      "text-indent": "0",
    },

    buttons: {
      "border-radius": "30px",
      border: "1px solid transparent",
      padding: "15px 30px",
      "font-weight": "700",
      "font-size": "12.5px",
      "letter-spacing": "0.12em",
      "text-transform": "uppercase",
      cursor: "pointer",
      transition: "background-color 0.22s ease, color 0.22s ease",
      "font-family": "Montserrat, sans-serif",
      "box-shadow": "0 10px 26px rgba(46,48,54,0.16)",
    },

    submitButton: {
      "background-color": "#7d9bb2",
      color: "#fff",
      "margin-top": "28px",
      "text-align": "center",
    },

    submitButtonHover: {
      "background-color": "#506374",
    },

    fieldContainer: {
      "margin-bottom": "20px",
      display: "flex",
      "flex-direction": "column",
    },

    // Checkbox styling
    checkboxFieldset: {
      border: "1px solid rgba(55,54,59,0.22)",
      "border-radius": "10px",
      padding: "16px",
      margin: "0",
      "box-sizing": "border-box",
      "background-color": "rgba(125,155,178,0.1)",
      "grid-column": "1 / -1",
    },

    checkboxLegend: {
      "font-size": "10px",
      "font-weight": "700",
      "letter-spacing": "0.18em",
      "text-transform": "uppercase",
      color: "#3f4b55",
      "margin-bottom": "12px",
      "font-family": "Montserrat, sans-serif",
      padding: "0",
    },

    checkboxOption: {
      display: "flex",
      "align-items": "center",
      "margin-bottom": "8px",
      cursor: "pointer",
    },

    checkboxInput: {
      "margin-right": "10px",
      "accent-color": "#7d9bb2",
    },

    checkboxLabel: {
      "font-size": "14px",
      color: "#586a78",
      "font-family": "Montserrat, sans-serif",
      cursor: "pointer",
    },

    // Textarea styling
    textarea: {
      "border-radius": "8px",
      border: "1px solid rgba(55,54,59,0.16)",
      padding: "13px 15px",
      "font-family": "Montserrat, sans-serif",
      "font-size": "15px",
      color: "#586a78",
      "background-color": "#fff",
      width: "100%",
      "box-sizing": "border-box",
      transition: "border-color 0.2s ease",
      resize: "vertical",
      "min-height": "130px",
      "line-height": "1.6",
    },
  }

  // Function to apply styles to shadow DOM
  function applyShadowDOMStyles() {
    // Try to find the contact form container by its specific parent ID
    const formSelectors = [
    'shopify-section-template--18534288130267__17519495962ad451b2',
      '#AaVJTYkYza2c1SDlUc__forms_inline_bVKerz',
      '#AaVJTYkYza2c1SDlUc__forms_inline_bVKerz [data-sizing="form-wrapper"]',
      '#AaVJTYkYza2c1SDlUc__forms_inline_bVKerz .contact-form',
      '#AaVJTYkYza2c1SDlUc__forms_inline_bVKerz [id*="shopify-section"]',
      '#AaVJTYkYza2c1SDlUc__forms_inline_bVKerz .shopify-app-block',
      '#AaVJTYkYza2c1SDlUc__forms_inline_bVKerz [data-shopify-app-id]',
    ]

    // Continue the dark hero backdrop from norcal-contact-page.liquid's
    // .ncp-backdrop (linear-gradient 160deg #2c2b30 -> #201f24 -> #17171a,
    // with a dark overlay reaching its darkest point near the bottom) so this
    // section doesn't cut to plain white right under the "Send Us a Message"
    // heading. This is a solid approximation of that gradient's darkest
    // stop - nudge the hex below if the seam between sections is visible.
    const sectionElement = document.querySelector("#shopify-section-template--18534288130267__17519495962ad451b2")
    if (sectionElement) {
      sectionElement.style.background = "#1c1b20"
    }

    let formContainer = null

    // Try each selector to find the form container
    for (const selector of formSelectors) {
      formContainer = document.querySelector(selector)
      if (formContainer) {
        break
      }
    }

    if (!formContainer) {
      return false
    }

    // Look for shadow DOM elements within the container
    const shadowHosts = formContainer.querySelectorAll("*")

    for (const element of shadowHosts) {
      if (element.shadowRoot) {
        injectShadowStyles(element.shadowRoot)
      }
    }

    // Also check if the container itself has shadow DOM
    if (formContainer.shadowRoot) {
      injectShadowStyles(formContainer.shadowRoot)
    }

    return true
  }

  // Function to inject styles into shadow DOM
  function injectShadowStyles(shadowRoot) {
    try {
      // Check if styles are already injected
      if (shadowRoot.querySelector("#contact-form-custom-styles")) {
        return
      }

      // Clean up any duplicate error messages
      cleanupDuplicateErrors(shadowRoot)

      // Create style element
      const style = document.createElement("style")
      style.id = "contact-form-custom-styles"

      // Build CSS rules
      let cssRules = ""

      // Form container styles - targeting the main form container.
      // Selector is doubled ([class*=x][class*=x]) purely to win specificity
      // ties against the app's own bundled stylesheet, which can be injected
      // into the shadow root after ours and would otherwise win on order.
      cssRules += `
        [class*="_formContainer"][class*="_formContainer"],
        [data-sizing="form-wrapper"][data-sizing="form-wrapper"] {
          ${objectToCSS(FORM_STYLES.container)}
          display: block !important;
          grid-template-columns: none !important;
          min-width: 0 !important;
        }
      `

      // The container above is normally a 2-column grid (an optional image
      // side-by-side with the field content, per its own "_noImage" state
      // class) - forcing it to display:block above stops that 2nd column
      // from reserving width, but the empty image-placeholder column and
      // the content column both need clearing out explicitly too, or the
      // form still renders inside a squeezed/offset width.
      cssRules += `
        [class*="_imageLoading"] {
          display: none !important;
        }
      `
      cssRules += `
        [class*="_gridItemContent"] {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
        }
      `

      // The grandparent grid (._inline_...) sizes its single implicit
      // column to this content's natural/max-content width since it has no
      // explicit track size of its own. Every nested grid/flex item here
      // defaults to min-width:auto, which lets intrinsic content sizing
      // (long placeholder/input default widths) inflate that column wider
      // than the visible area - which ._inline_...'s own overflow:hidden
      // then clips, exactly matching the "cut off, not centered" symptom.
      // min-width:0 everywhere in the chain stops that inflation.
      cssRules += `
        [class*="_formContainer"],
        [class*="_gridItemContent"],
        [class*="_formFieldset"],
        [class*="_formFieldContainer"],
        [class*="_formInputField"],
        [class*="_textArea"],
        [class*="_checkboxFieldSet"] {
          min-width: 0 !important;
        }
      `

      // Hide the app's own built-in heading/description - the theme's
      // "Send Us a Message" heading directly above this section already
      // covers it, so this avoided a redundant duplicate title.
      cssRules += `
        [class*="_formHeader"] {
          display: none !important;
        }
      `

      // Hide the Shop Pay lead-capture widget - it's an empty custom
      // element rendered as a direct child of the (display:grid) form, so
      // without this it becomes a real, empty grid cell that shifts every
      // field after it by one column/row.
      cssRules += `
        shop-lead-capture,
        shop-lead-capture + *,
        div:has(> shop-lead-capture) {
          display: none !important;
        }
      `

      // Form fieldset (the main form wrapper)
      cssRules += `
        [class*="_formFieldset"][class*="_formFieldset"] {
          display: grid !important;
          grid-template-columns: 1fr 1fr !important;
          gap: 20px !important;
          width: 100% !important;
        }
      `

      // Form field containers
      cssRules += `
        [class*="_formFieldContainer"] {
          ${objectToCSS(FORM_STYLES.fieldContainer)}
        }
      `

      // Input field styles
      cssRules += `
        [class*="_formInputField"] {
          ${objectToCSS(FORM_STYLES.inputs)}
        }
      `

      // Textarea styles
      cssRules += `
        [class*="_textArea"],
        textarea {
          ${objectToCSS(FORM_STYLES.textarea)}
        }
      `

      // Label styles (static micro-label above the field, not a floating
      // placeholder - scoped to the text/textarea label class specifically
      // so it never touches the unrelated checkbox option labels below)
      cssRules += `
        [class*="_formInputFieldLabel"] {
          ${objectToCSS(FORM_STYLES.labels)}
        }
      `

      // Submit button styles
      cssRules += `
        [class*="_formSubmitButton"],
        button[type="submit"] {
          ${objectToCSS({ ...FORM_STYLES.buttons, ...FORM_STYLES.submitButton })}
          grid-column: 1 / -1 !important;
          max-width: 320px !important;
          margin: 28px auto 0 auto !important;
          display: block !important;
        }
      `

      // Submit button hover styles
      cssRules += `
        [class*="_formSubmitButton"]:hover,
        button[type="submit"]:hover {
          ${objectToCSS(FORM_STYLES.submitButtonHover)}
        }
      `

      // Focus styles
      cssRules += `
        [class*="_formInputField"]:focus,
        [class*="_textArea"]:focus {
          outline: none !important;
          border-color: #7d9bb2 !important;
        }
      `

      // Checkbox fieldset styling
      cssRules += `
        [class*="_checkboxFieldSet"][class*="_checkboxFieldSet"] {
          ${objectToCSS(FORM_STYLES.checkboxFieldset)}
          display: block !important;
          grid-column: 1 / -1 !important;
        }
      `

      // Checkbox legend styling
      cssRules += `
        [class*="_checkboxLegend"] {
          ${objectToCSS(FORM_STYLES.checkboxLegend)}
        }
      `

      // Checkbox option wrapper (holds just the <input>)
      cssRules += `
        [class*="_checkboxWrapper"] {
          display: flex !important;
          align-items: center !important;
        }
      `

      // Checkbox input styling
      cssRules += `
        [class*="_checkboxInput"] {
          ${objectToCSS(FORM_STYLES.checkboxInput)}
          width: auto !important;
          position: relative !important;
          top: auto !important;
          left: auto !important;
        }
      `

      // Checkbox label text styling
      cssRules += `
        [class*="_checkboxField"] [class*="_textBody"] {
          ${objectToCSS(FORM_STYLES.checkboxLabel)}
          margin: 0 !important;
        }
      `

      // Specific checkbox label container styling - each option's <label>
      // wraps the checkbox + its text, so this stays position:static/flex
      // rather than picking up the text-field label's static-above-input
      // treatment (that one is scoped to [class*="_formInputFieldLabel"]
      // only, which checkbox labels never carry, so there's no overlap)
      cssRules += `
        [class*="_checkboxField"] {
          position: static !important;
          display: flex !important;
          align-items: center !important;
          margin-bottom: 8px !important;
          cursor: pointer !important;
          background-color: transparent !important;
          padding: 0 !important;
          border: none !important;
          top: auto !important;
          left: auto !important;
          transform: none !important;
          pointer-events: auto !important;
        }
      `

      // Styling for checkbox fields parent container
      cssRules += `
        [class*="_verticalLayout"] {
          padding-left: 0;
          padding-top: 0;
        }
      `

      // Ensure certain fields span full width
      cssRules += `
        [class*="_formFieldContainer"]:has(textarea),
        [class*="_formFieldContainer"]:has([class*="_textArea"]) {
          grid-column: 1 / -1 !important;
        }
      `

      // The app draws a decorative ::before on the textarea's field
      // container (its own background swatch) that was rendered on top of
      // and covering the "Message" label - killing it entirely.
      cssRules += `
        [class*="_formFieldContainer"]:has(textarea)::before,
        [class*="_formFieldContainer"]:has([class*="_textArea"])::before {
          display: none !important;
          content: none !important;
          background: none !important;
        }
      `


      // Responsive design - mobile stacking
      cssRules += `
        @media (max-width: 768px) {
          [class*="_formFieldset"][class*="_formFieldset"] {
            grid-template-columns: 1fr !important;
            gap: 16px !important;
          }
        }
      `

      // Additional responsive breakpoint for 700px and below. `width: auto`
      // is required here (overriding the base rule's `width: 100%`) - with
      // box-sizing:border-box a 100%-width block plus a nonzero margin
      // overflows its parent by exactly the margin amount, causing
      // horizontal scroll; auto-width blocks size themselves around their
      // margins correctly instead.
      cssRules += `
        @media (max-width: 700px) {
          [class*="_formContainer"][class*="_formContainer"],
          [data-sizing="form-wrapper"][data-sizing="form-wrapper"] {
            width: auto !important;
            padding: 24px 16px !important;
            margin: 0 6px !important;
          }

          [class*="_formFieldContainer"] {
            margin-bottom: 14px !important;
          }

          [class*="_formInputField"],
          [class*="_textArea"] {
            font-size: 16px !important;
            padding: 12px !important;
          }

          [class*="_checkboxFieldSet"][class*="_checkboxFieldSet"] {
            padding: 12px !important;
          }

          [class*="_formSubmitButton"],
          button[type="submit"] {
            max-width: 100% !important;
          }
        }
      `

      // Small-phone breakpoint
      cssRules += `
        @media (max-width: 420px) {
          [class*="_formContainer"][class*="_formContainer"],
          [data-sizing="form-wrapper"][data-sizing="form-wrapper"] {
            padding: 20px 14px !important;
            margin: 0 4px !important;
            border-radius: 10px !important;
          }

          [class*="_textArea"] {
            min-height: 110px !important;
          }
        }
      `

      // Ensure proper field spacing
      cssRules += `
        [class*="_formFieldContainer"] + [class*="_formFieldContainer"] {
          margin-top: 0 !important;
        }
      `

      style.textContent = cssRules

      // Insert styles at the beginning of shadow DOM
      shadowRoot.insertBefore(style, shadowRoot.firstChild)

    } catch (error) {
      console.error("Error injecting shadow DOM styles:", error)
    }
  }

  // Function to cleanup duplicate error messages
  function cleanupDuplicateErrors(shadowRoot) {
    try {
      // Find all error message containers
      const errorContainers = shadowRoot.querySelectorAll('[class*="_formErrors"], .form-errors')

      if (errorContainers.length > 1) {
        // Keep only the first error container, remove the rest
        for (let i = 1; i < errorContainers.length; i++) {
          errorContainers[i].remove()
        }
      }

      // Also remove any error messages that appear after the submit button
      const submitButton = shadowRoot.querySelector('[class*="_formSubmitButton"], button[type="submit"]')
      if (submitButton) {
        let nextElement = submitButton.nextElementSibling
        while (nextElement) {
          if (nextElement.classList.contains('form-errors') ||
              nextElement.querySelector('[class*="_formErrors"]')) {
            nextElement.remove()
          }
          nextElement = nextElement.nextElementSibling
        }
      }
    } catch (error) {
      console.error("Error cleaning up duplicate errors:", error)
    }
  }

  // Helper function to convert object to CSS string
  function objectToCSS(styleObj) {
    return Object.entries(styleObj)
      .map(([property, value]) => `${property}: ${value} !important;`)
      .join(" ")
  }

  // Observer to watch for form loading
  function observeForForms() {
    // Configuration for the observer
    const config = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "id"],
    }

    // Callback function to execute when mutations are observed
    const callback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          // Debounce the style application
          clearTimeout(window.contactFormStyleTimeout)
          window.contactFormStyleTimeout = setTimeout(() => {
            applyShadowDOMStyles()
            // Also clean up any error messages that might have appeared
            cleanupFormErrors()
          }, 100)
        }
      }
    }

    // Create an observer instance
    const observer = new MutationObserver(callback)

    // Start observing
    observer.observe(document.body, config)
  }

  // Function to clean up form errors dynamically
  function cleanupFormErrors() {
    try {
      // Find all shadow roots in the document
      const shadowHosts = document.querySelectorAll('*')

      shadowHosts.forEach(element => {
        if (element.shadowRoot) {
          cleanupDuplicateErrors(element.shadowRoot)
        }
      })
    } catch (error) {
      console.error("Error cleaning up form errors:", error)
    }
  }

  // Initialize the styling system
  function init() {
    // Try to apply styles immediately
    applyShadowDOMStyles()

    // Set up observer for dynamic content
    observeForForms()

    // Retry after a delay in case forms load later
    setTimeout(() => {
      applyShadowDOMStyles()
    }, 1000)

    // Retry on window load
    if (document.readyState === "loading") {
      window.addEventListener("load", () => {
        setTimeout(() => {
          applyShadowDOMStyles()
        }, 500)
      })
    }
  }

  // Start when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
})()

// Additional utility functions for manual styling if needed
window.ContactFormStyler = {
  // Manual trigger for applying styles
  applyStyles: () => {
    window.applyShadowDOMStyles()
  },

  // Update styles with custom configuration
  updateStyles: (newStyles) => {
    Object.assign(window.FORM_STYLES, newStyles)
    window.applyShadowDOMStyles()
  },
}
